import { render } from "./DetalhesProdutosCliente.vue?vue&type=template&id=62c50698&scoped=true"
import script from "./DetalhesProdutosCliente.vue?vue&type=script&lang=js"
export * from "./DetalhesProdutosCliente.vue?vue&type=script&lang=js"

import "./DetalhesProdutosCliente.vue?vue&type=style&index=0&id=62c50698&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62c50698"]])

export default __exports__